module.exports = __webpack_public_path__ + "img/g1.7f6259b9.jpg";